import DropdownClassList from "root/s360components/ReactHookForm/ui/DropdownClassList";
import {FormInputDatePicker} from "root/ReactHookForm/FormComponents";
import DropdownAMPM, {AM_OBJ, PM_OBJ} from "root/s360components/ReactHookForm/ui/DropdownAMPM";
import ToggleIncludeLunch from "root/s360components/ReactHookForm/ui/ToggleIncludeLunch";
import './HookSubFormRegistrationFilter.scss';
import {RegistrationFormSections} from "root/s360components/Registration/RegistrationPage";
import useWatchDropdown from "root/ReactHookForm/ui/useWatchDropdown";
import {Fragment, useEffect, useState} from "react";
import DropdownArborGroupList from "root/s360components/ReactHookForm/ui/DropdownArborGroupList";
import {useWatch} from "react-hook-form";
import format from "date-fns/format";
import isValid from "date-fns/isValid";
import {getMisWritebackEnabled} from "root/DataFunctions/RegistrationDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";


export const RegistrationFilterNames = {
    CLASSES: 'classes',
    DATE: 'date',
    SESSION: 'ampm',
    LUNCH: 'lunchtoggle',
    GROUPS: 'groups',
}

export const MisType = {
    WONDE: 1,
    ARBOR: 2,
    UNKNOWN: 99
}

export const regFilters = (initialSessionObject) =>
{
    return {
        [RegistrationFormSections.FILTERS]:
            {
                [RegistrationFilterNames.CLASSES]: { value: 0 , label: "No classes"},
                [RegistrationFilterNames.DATE]: Date.now(),
                [RegistrationFilterNames.SESSION]: initialSessionObject !== null ? initialSessionObject : { value: 0 , label: "No sessions"},
                [RegistrationFilterNames.LUNCH]: false,
                [RegistrationFilterNames.GROUPS]: { value: 0 , label: "No groups"}
            }
    }
}

const HookSubFormRegistrationFilters = ({control, resetField, watch, getValues, setValue, formErrors, sectionName, readOnly, school_id, class_id_filter}) =>
{

    const [data, setData] = useState({isLoading: true, data: []});

    const sessionOptions = [
        AM_OBJ,
        PM_OBJ,
    ]

    useEffect(() => {

        getData();
    }, [school_id])


    const getData = () =>
    {
        getMisWritebackEnabled(school_id, (response) =>
        {
            const rows = getDataFromResponse(response);

            if (rows.length > 0)
            {
                const isArbor = rows[0].mis_type === MisType.ARBOR;

                setData({isLoading: false, data: {isArbor: isArbor}});
            }
            else
            {
                setData({isLoading: false, data: {isArbor: false}})
            }
        })
    }

    //Captured from the class dropdown so the non-arbor class list can be shared downstream
    const [ classItems, setClassItems ] = useState([]);

    //The arbor group list is only fetched once the date and session are both chosen, and stays disabled until then
    const [ session ] = useWatchDropdown({control, name: sectionName + '.' + RegistrationFilterNames.SESSION, isInt: false});

    const watchDate = useWatch({control, name: sectionName + '.' + RegistrationFilterNames.DATE});

    //The date picker gives us a Date, but the initial form value is a timestamp. Both format the same way.
    //A cleared or half typed date is left as null so the arbor list stays disabled
    const registrationDate = isValid(watchDate) ? format(watchDate, "yyyy-MM-dd") : null;

    //The default placeholder uses a value of 0, so the session is only really chosen once it has a genuine value
    const sessionSelected = session !== null && session !== undefined && session !== 0;

    //The arbor group list now filters on date and session alone - no class needs to be chosen first
    const arborEnabled = registrationDate !== null && sessionSelected;

    return (
        <Fragment>
            <div className='registration-filter registration-filter--date'>
                <span className='registration-filter__label'>Date</span>
                <FormInputDatePicker control={control} sectionName={sectionName} name={RegistrationFilterNames.DATE} formErrors={formErrors} readOnly={false} maxDate={new Date()}/>
            </div>
            <div className='registration-filter'>
                <span className='registration-filter__label'>Session</span>
                <DropdownAMPM control={control} name={sectionName + '.' + RegistrationFilterNames.SESSION} readOnly={false} placeholder={"Please select a time"} options={sessionOptions}/>
            </div>
            {data.data.isArbor === true && <div className='registration-filter'>
                <span className='registration-filter__label'>Class</span>
                <DropdownArborGroupList control={control} school_id={school_id} name={sectionName + '.' + RegistrationFilterNames.CLASSES} readOnly={false} placeholder={"Please select a class"} session={session} date={registrationDate} enabled={arborEnabled}/>
            </div>}
            {data.data.isArbor === false && <div className='registration-filter'>
                <span className='registration-filter__label'>Class</span>
                <DropdownClassList control={control} school_id={school_id} name={sectionName + '.' + RegistrationFilterNames.CLASSES} readOnly={false} placeholder={"Please select a class"} class_id_filter={class_id_filter} setValue={setValue} onItemsLoaded={setClassItems}/>
            </div>}
            <div className='registration-filter registration-filter--lunch'>
                <span className='registration-filter__label'>Include lunch</span>
                <ToggleIncludeLunch control={control} name={sectionName + '.' + RegistrationFilterNames.LUNCH} readOnly={false}/>
            </div>
        </Fragment>
    )
}

export default HookSubFormRegistrationFilters;